import React from 'react';

import { DownloadOutlined } from '@ant-design/icons';
import { Button as AntdButton } from 'antd';

import { TableSort } from 'components/WrappedComponents/Table/types';
import { useExportAdminDashboard } from 'hooks/dossiers/useExportDashboard';

import { DashboardAdminFonctionnelFilter } from '../../types';

interface DownloadButtonProps<SortType extends string | undefined> {
  filters: Partial<DashboardAdminFonctionnelFilter>;
  sort: TableSort<SortType>;
}

function DownloadButton<SortType extends string | undefined>({
  filters,
  sort,
}: DownloadButtonProps<SortType>): React.ReactElement {
  const { exportDashboard, inProgress } = useExportAdminDashboard();

  return (
    <AntdButton
      icon={<DownloadOutlined />}
      type={'default'}
      shape={'round'}
      onClick={() => {
        exportDashboard(sort, {
          dateRangeMiseEnFourriere: filters.dateRangeMiseEnFourriere,
          idNatureBrancheList: filters.natureMiseEnFourriere,
          statutDossierEnumList: filters.statut,
          classementList: filters.classement,
          dateRangeBonEnlevement: filters.dateRangeBonEnlevement,
          dateRangeSortieDefinitive: filters.dateRangeSortieDefinitive,
          idFourriereList: filters.fourriere,
          includeDossiersSortis: filters.includeDossiersSortis,
          numeroRecherche: filters.search,
          idMotifSortieList: filters.motifDeSortie,
          statutsFacturation: filters.statutsTraitementFacturation,
          includeDossiersAnonymises: filters.includeDossiersAnonymises,
          dateRangeOrdreDestruction: filters.dateRangeOrdreDestruction,
          listUniteFo: filters.idUniteFOList,
          actionsRequises: filters.actionsRequises,
          marque: filters.idMarque,
          modele: filters.idModele,
          idJuridictionList: filters.idJuridictionList,
        });
      }}
      loading={inProgress}
    />
  );
}

export default DownloadButton;
